var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#773DD3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.89184 12.8906L16.1645 12.8906L14.7941 14.2544C14.6412 14.4066 14.6406 14.6539 14.7928 14.8068C14.9449 14.9597 15.1923 14.9603 15.3452 14.8081L17.3863 12.7769C17.3864 12.7768 17.3865 12.7766 17.3866 12.7765C17.5392 12.6243 17.5397 12.3762 17.3867 12.2235C17.3865 12.2234 17.3864 12.2232 17.3863 12.2231L15.3452 10.1919C15.1923 10.0397 14.945 10.0403 14.7928 10.1932C14.6406 10.3461 14.6412 10.5934 14.7941 10.7456L16.1645 12.1094L7.89184 12.1094C7.6761 12.1094 7.50122 12.2843 7.50122 12.5C7.50122 12.7157 7.6761 12.8906 7.89184 12.8906Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(17.5012 17.5) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionArrow);
export default __webpack_public_path__ + "static/media/subscription-arrow.41e7e9fd8653223adc8de8aba8226b51.svg";
export { ForwardRef as ReactComponent };